module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"questionNotSaved":"You did not save the question","continue":"Continue editing","done":"Done"}}')
  delete Component.options._Ctor
}
